<template>
  <el-space size="large">
    <logo class="logo_name_header" />
    <menus />
  </el-space>
  <el-space size="small">
    <task />
    <!-- <app-time-zone-select /> -->
    <full-screen />
    <user-info />
  </el-space>
</template>

<script lang="ts" setup>
import Logo from './Logo.vue'
import FullScreen from './FullScreen.vue'
import UserInfo from './UserInfo.vue'
import Menus from './Menus.vue'
import Task from './Task.vue'
</script>

<style lang="less" scoped>
i {
  font-size: 19px;
  cursor: pointer;
}

.logo_name_header {
  margin-right: 25px;
}
</style>
